export default "__VITE_ASSET__CFtX_8i3__"